"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _CheckCanOpenComponent = _interopRequireDefault(require("../../MainMenu/CheckCanOpenComponent"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _EquizzerActions = _interopRequireDefault(require("../actions/EquizzerActions"));

var _Feature = _interopRequireDefault(require("../../../../utils/features/Feature"));

var _FeatureManager = _interopRequireDefault(require("../../../../utils/features/FeatureManager"));

var _CourseLoader = _interopRequireDefault(require("../../../../helpers/CourseLoader"));

var _ErrorHelper = require("../../../../helpers/ErrorHelper");

var _strings = require("./strings");

var _NavigationManager = _interopRequireDefault(require("../../../NavigationManager"));

var _AlertHelper = require("../../../../helpers/AlertHelper");

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var _UserManagementService = _interopRequireDefault(require("../services/UserManagementService"));

var _TournamentStateHelper = _interopRequireDefault(require("../../../../helpers/TournamentStateHelper"));

var _EquizzerRegisterHelper = require("../EquizzerRegisterHelper");

var _StringHelper = _interopRequireDefault(require("../../../../helpers/StringHelper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _AppUtils = require("../../../../utils/AppUtils");

var _QuizOfflineHelper = _interopRequireDefault(require("../services/QuizOfflineHelper"));

var _RegisterInstance = _interopRequireDefault(require("../../../../KESI2/Services/RegisterInstance"));

var _RestService = _interopRequireDefault(require("../services/RestService"));

var _CourseHelper = _interopRequireDefault(require("../../../../helpers/CourseHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_GROUP_CODE = 'Standard';

var EquizzerCanOpenChecker = /*#__PURE__*/function (_CheckCanOpenComponen) {
  (0, _inherits2["default"])(EquizzerCanOpenChecker, _CheckCanOpenComponen);

  var _super = _createSuper(EquizzerCanOpenChecker);

  (0, _createClass2["default"])(EquizzerCanOpenChecker, null, [{
    key: "checkForQd",
    value: function checkForQd(code, skipGroupName) {
      var equizzerCanOpenChecker = new EquizzerCanOpenChecker();
      equizzerCanOpenChecker.onOpen(code, skipGroupName);
    }
  }]);

  function EquizzerCanOpenChecker(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, EquizzerCanOpenChecker);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onReauthorizationRequested", function () {
      if (_this.showLocked === false) {
        (0, _AlertHelper.showAlertWithOptions)({
          html: (0, _strings.getString)('DEVICE_LOCKED_EXPLANATION'),
          title: (0, _strings.getString)('DEVICE_LOCKED'),
          centeredContent: true,
          buttons: [{
            label: 'OK',
            callback: function callback() {
              _NavigationManager["default"].goHome();
            }
          }]
        });
      }

      _this.showLocked = true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(code, skipGroupName) {
        var defaultGroupCode, activatedFeatures, activated;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.alreadyOpen) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", false);

              case 2:
                defaultGroupCode = _config["default"].forcedActivationCode || DEFAULT_GROUP_CODE;
                _this.code = _config["default"].activateWithPersonalNumber ? '' : code ? code : defaultGroupCode;
                _this.nickName = '';
                _this.password = '';
                _this.password2 = '';
                _this.email = null;
                _this.alreadyOpen = true;
                setTimeout(function () {
                  _this.alreadyOpen = false;
                }, 10000);
                _context.prev = 10;
                activatedFeatures = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_ACTIVATED_FEATURES);
                activated = activatedFeatures && activatedFeatures.includes(_EquizzerRegisterHelper.FEATURE_QD); // we have to create a new promise here to give the resolve function down to the other functions, sorry ESLint

                return _context.abrupt("return", new _promise["default"](function (resolve) {
                  // eslint-disable-line promise/avoid-new
                  // With standard groups possibly activated -> allow chaning a group even when activated before
                  // if (activated) {
                  //   resolve(true)
                  //   return
                  // }
                  if (_this.code && (_this.code !== defaultGroupCode && skipGroupName || _config["default"].skipGroupName)) {
                    // skip activation code dialog as the code had already been set from server (e.g. via SysMessage) or is hardcoded via the target config
                    _this.enterNickName(resolve);

                    return;
                  }

                  if (_config["default"].activateWithPersonalNumber) {
                    (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('ENTER_PERSONAL_NUMBER_EXPLANATION'), (0, _strings.getString)('ENTER_PERSONAL_NUMBER'), null, [{
                      label: (0, _strings.getString)('PERSONAL_NUMBER'),
                      className: 'textField',
                      value: _this.code,
                      onChange: _this.setActivationCode,
                      onFocus: _this.onFocus,
                      onBlur: _this.onBlur
                    }], true, null, [{
                      label: (0, _strings.getString)('OK'),
                      callback: function callback() {
                        _this.checkActivationCodeAndCheckUser(resolve);
                      }
                    }]);
                  } else {
                    (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('ENTER_GROUP_EXPLANATION'), (0, _strings.getString)('ENTER_GROUP'), null, [{
                      label: (0, _strings.getString)('GROUP_CODE'),
                      className: 'textField',
                      value: _this.code,
                      onChange: _this.setActivationCode,
                      onFocus: _this.onFocus,
                      onBlur: _this.onBlur
                    }], true, null, [{
                      label: (0, _strings.getString)('OK'),
                      callback: function callback() {
                        _this.enterNickName(resolve);
                      }
                    }]);
                  }
                }));

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](10);
                return _context.abrupt("return", _promise["default"].resolve(false));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[10, 16]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocus", function () {
      var alertHelperInput = document.querySelector('.equizzer-modal div div:nth-child(2)'); // this.setState({modalTop: alertHelperInput.style.top})

      _this.modalTop = alertHelperInput.style.top;
      console.log('on focus', _this.modalTop);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function () {
      console.log('on blur', _this.modalTop);
      var alertHelperInput = document.querySelector('.equizzer-modal div div:nth-child(2)');
      alertHelperInput.style.top = _this.modalTop;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setActivationCode", function (event) {
      var code = event.target.value;
      console.log('code', code);

      if (_config["default"].useNumberRegexForActivationCode) {
        _this.code = code.replace(/\D+/g, '');
      } else {
        _this.code = code;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setEmail", function (event) {
      _this.email = event.target.value; // this.setState({nickName})
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setNickname", function (event) {
      _this.nickName = event.target.value; // this.setState({nickName})
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setPassword", function (event) {
      _this.password = event.target.value; // this.setState({password})
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setPassword2", function (event) {
      _this.password2 = event.target.value; // this.setState({password2})
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkActivationCodeAndCheckUser", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(resolve) {
        var returnValue;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _UserManagementService["default"].checkActivationCode(_this.code, null, _config["default"].useDrupalContent);

              case 3:
                returnValue = _context2.sent;
                // this.setState({userName: returnValue.username})
                console.log('checkActivationCodeAndCheckUser returnValue', returnValue);

                if (returnValue.success && returnValue.firstname && returnValue.lastname) {
                  _this.nickName = returnValue.firstname + ' ' + returnValue.lastname;

                  if (typeof returnValue.features === 'string') {
                    _this.features = [returnValue.features];
                  } else {
                    _this.features = returnValue.features;
                  }

                  _this.checkUser(resolve, true);
                } else {
                  setTimeout(function () {
                    (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('ENTER_PERSONAL_NUMBER_EXPLANATION'), (0, _strings.getString)('ENTER_PERSONAL_NUMBER'), (0, _strings.getString)('PERSONAL_NUMBER_NO_DATA'), [{
                      label: (0, _strings.getString)('PERSONAL_NUMBER'),
                      className: 'textField',
                      value: _this.code,
                      onChange: _this.setActivationCode,
                      onFocus: _this.onFocus,
                      onBlur: _this.onBlur
                    }], true, null, [{
                      label: (0, _strings.getString)('OK'),
                      callback: function callback() {
                        _this.checkActivationCodeAndCheckUser(resolve);
                      }
                    }]);
                  }, 0);
                }

                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('ENTER_PERSONAL_NUMBER_EXPLANATION'), (0, _strings.getString)('ENTER_PERSONAL_NUMBER'), (0, _ErrorHelper.getErrorMessage)(_context2.t0), [{
                  label: (0, _strings.getString)('PERSONAL_NUMBER'),
                  className: 'textField',
                  value: _this.code,
                  onChange: _this.setActivationCode,
                  onFocus: _this.onFocus,
                  onBlur: _this.onBlur
                }], true, null, [{
                  label: (0, _strings.getString)('OK'),
                  callback: function callback() {
                    _this.checkActivationCodeAndCheckUser(resolve);
                  }
                }]);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "enterNickName", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(resolve) {
        var online, returnValue, textFields, explanation, errorMessage;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                online = _DeviceInfoHelper["default"].isOnline();

                if (online) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 4;
                return (0, _TimeoutHelper.timeout)(500);

              case 4:
                _this.enterNickName(resolve);

                return _context3.abrupt("return");

              case 6:
                _context3.prev = 6;
                _context3.next = 9;
                return _UserManagementService["default"].checkActivationCode(_this.code, null, _config["default"].useDrupalContent);

              case 9:
                returnValue = _context3.sent;
                console.log('returnValue enterNickName', returnValue);

                if (returnValue.success) {
                  _this.groupName = returnValue.group;

                  if (typeof returnValue.features === 'string') {
                    _this.features = [returnValue.features];
                  } else {
                    _this.features = returnValue.features;
                  }

                  _this.requiresEmail = returnValue.requiresEmail;
                  textFields = [{
                    label: (0, _strings.getString)('PLAYER_NICKNAME'),
                    value: _this.nickName,
                    onChange: _this.setNickname,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur
                  }];
                  explanation = (0, _strings.getString)('PLAYER_NICKNAME_EXPLANATION', [_this.groupName]);
                  (0, _AlertHelper.showWideAlertHtmlWithTextfields)(explanation, (0, _strings.getString)('PLAYER_NICKNAME'), null, textFields, true, null, [{
                    label: (0, _strings.getString)('OK'),
                    callback: function callback() {
                      return _this.checkUser(resolve);
                    }
                  }]);
                } else {
                  (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('ENTER_GROUP_EXPLANATION'), (0, _strings.getString)('ENTER_GROUP'), (0, _strings.getString)('GROUP_CODE_WRONG'), [{
                    label: (0, _strings.getString)('GROUP_CODE'),
                    value: _this.code,
                    onChange: _this.setActivationCode,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur
                  }], true, null, [{
                    label: (0, _strings.getString)('OK'),
                    callback: function callback() {
                      _this.enterNickName(resolve);
                    }
                  }]);
                }

                _context3.next = 20;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](6);
                errorMessage = (0, _ErrorHelper.getErrorMessage)(_context3.t0);

                if (_context3.t0 === 'code is empty') {
                  errorMessage = (0, _strings.getString)('ENTER_GROUP_EMPTY');
                } else if (_context3.t0 === 'code not found' || _context3.t0 === 'code has wrong format') {
                  errorMessage = (0, _strings.getString)('GROUP_CODE_WRONG');
                }

                console.log(_context3.t0);
                (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('ENTER_GROUP_EXPLANATION'), (0, _strings.getString)('ENTER_GROUP'), errorMessage, [{
                  label: (0, _strings.getString)('GROUP_CODE'),
                  value: _this.code,
                  onChange: _this.setActivationCode,
                  onFocus: _this.onFocus,
                  onBlur: _this.onBlur
                }], true, null, [{
                  label: (0, _strings.getString)('OK'),
                  callback: function callback() {
                    _this.enterNickName(resolve);
                  }
                }]);

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[6, 14]]);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkUser", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(resolve) {
        var isOnlyActivationCodeLogin,
            error,
            returnValue,
            NUMERIC_VALUE_FOR_TRUE,
            reset,
            allowPasswordReset,
            pwResetButton,
            buttons,
            explanation,
            textFields,
            _textFields,
            _explanation,
            _args4 = arguments;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                isOnlyActivationCodeLogin = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
                error = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : null;
                _context4.prev = 2;
                console.log('checkUser', _this.code, _this.nickName);
                _context4.next = 6;
                return _UserManagementService["default"].checkActivationCode(_this.code, _this.nickName, _config["default"].useDrupalContent);

              case 6:
                returnValue = _context4.sent;
                // this.setState({userName: returnValue.username})
                _this.userName = returnValue.username;
                NUMERIC_VALUE_FOR_TRUE = 1;
                reset = returnValue.reset_password ? returnValue.reset_password : false;
                console.log('checkUser', returnValue);
                allowPasswordReset = returnValue.allowPasswordReset;
                pwResetButton = {
                  label: (0, _strings.getString)('PASSWORD_RESET'),
                  callback: function callback() {
                    _this.resetPassword(isOnlyActivationCodeLogin);
                  },
                  theme: 'pwReset'
                };
                buttons = [{
                  label: (0, _strings.getString)('OK'),
                  callback: function callback() {
                    _this.revalidateUser(resolve, isOnlyActivationCodeLogin);
                  }
                }];
                if (allowPasswordReset) buttons.push(pwResetButton);
                console.log('allowPasswordReset: ', allowPasswordReset);

                if ((returnValue.must_authorize === NUMERIC_VALUE_FOR_TRUE || returnValue.must_authorize === true || returnValue.pin_locked === true) && !reset) {
                  (0, _AlertHelper.showWideAlertHtmlWithTextfields)(isOnlyActivationCodeLogin ? (0, _strings.getString)('LOGIN_EXPLANATION_ERGO', [_this.nickName]) : (0, _strings.getString)('LOGIN_EXPLANATION', [_this.nickName]), (0, _strings.getString)('LOGIN'), error, [{
                    label: (0, _strings.getString)('PASSWORD'),
                    style: {
                      paddingBottom: '10px'
                    },
                    value: _this.password,
                    onChange: _this.setPassword,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur,
                    type: 'password'
                  }], true, null, buttons);
                } else if (returnValue.must_personalize === NUMERIC_VALUE_FOR_TRUE || returnValue.must_personalize === true) {
                  explanation = _this.requiresEmail ? (0, _strings.getString)('PLAYER_PASSWORD_EMAIL_EXPLANATION', [_this.nickName]) : isOnlyActivationCodeLogin ? (0, _strings.getString)('REGISTER_EXPLANATION_ERGO', [_this.nickName]) : (0, _strings.getString)('REGISTER_EXPLANATION', [_this.nickName]);
                  textFields = [];
                  textFields.push({
                    label: (0, _strings.getString)('PASSWORD'),
                    value: _this.password,
                    onChange: _this.setPassword,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur,
                    type: 'password'
                  }, {
                    label: (0, _strings.getString)('PASSWORD_REPEAT'),
                    value: _this.password2,
                    onChange: _this.setPassword2,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur,
                    type: 'password'
                  });

                  if (_this.requiresEmail) {
                    textFields.push({
                      label: (0, _strings.getString)('PLAYER_EMAIL'),
                      value: _this.email,
                      onChange: _this.setEmail,
                      onFocus: _this.onFocus,
                      onBlur: _this.onBlur,
                      type: 'email'
                    });
                  }

                  (0, _AlertHelper.showWideAlertHtmlWithTextfields)(explanation, (0, _strings.getString)('REGISTER'), null, textFields, true, null, [{
                    label: (0, _strings.getString)('OK'),
                    callback: function callback() {
                      _this.registerUser(resolve);
                    }
                  }]);
                } else if ((returnValue.must_authorize === NUMERIC_VALUE_FOR_TRUE || returnValue.must_authorize === true) && reset) {
                  (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)(isOnlyActivationCodeLogin ? 'ERGO_RESET_EXPLANATION' : 'RESET_EXPLANATION', [_this.nickName]), (0, _strings.getString)('RESET_TITLE'), null, [{
                    label: (0, _strings.getString)('PASSWORD'),
                    value: _this.password,
                    onChange: _this.setPassword,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur,
                    type: 'password'
                  }, {
                    label: (0, _strings.getString)('PASSWORD_REPEAT'),
                    value: _this.password2,
                    onChange: _this.setPassword2,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur,
                    type: 'password'
                  }], true, null, [{
                    label: (0, _strings.getString)('OK'),
                    callback: function callback() {
                      _this.changePassword(resolve, isOnlyActivationCodeLogin);
                    }
                  }, {
                    label: (0, _strings.getString)('PASSWORD_RE_RESET'),
                    callback: function callback() {
                      _this.resetPassword(isOnlyActivationCodeLogin);
                    },
                    theme: 'pwReset'
                  }]);
                }

                _context4.next = 23;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4["catch"](2);
                console.log(_context4.t0);

                if (isOnlyActivationCodeLogin) {
                  _this.checkUser(resolve, isOnlyActivationCodeLogin, _context4.t0.message);
                } else {
                  _textFields = [];

                  if (_this.requiresEmail) {
                    _textFields.push({
                      label: (0, _strings.getString)('PLAYER_EMAIL'),
                      value: _this.email,
                      onChange: _this.setEmail,
                      onFocus: _this.onFocus,
                      onBlur: _this.onBlur,
                      type: 'email'
                    });
                  }

                  _textFields.push({
                    label: (0, _strings.getString)('PLAYER_NICKNAME'),
                    value: _this.nickName,
                    onChange: _this.setNickname,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur
                  });

                  _explanation = _this.requiresEmail ? (0, _strings.getString)('PLAYER_NICKNAME_EMAIL_EXPLANATION') : (0, _strings.getString)('PLAYER_NICKNAME_EXPLANATION');
                  (0, _AlertHelper.showWideAlertHtmlWithTextfields)(_explanation, (0, _strings.getString)('PLAYER_NICKNAME'), (0, _ErrorHelper.getErrorMessage)(_context4.t0), _textFields, true, null, [{
                    label: (0, _strings.getString)('OK'),
                    callback: function callback() {
                      return _this.checkUser(resolve);
                    }
                  }]);
                }

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 19]]);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "resetPassword", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(isOnlyActivationCodeLogin) {
        var explanation;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _TimeoutHelper.timeout)();

              case 2:
                _context5.prev = 2;
                _context5.next = 5;
                return _UserManagementService["default"].requestPasswordReset(_this.userName, _this.code, null, _config["default"].useDrupalContent);

              case 5:
                explanation = _this.requiresEmail ? (0, _strings.getString)('PASSWORD_MAIL_RESET_EXPLANATION', [_this.nickName]) : isOnlyActivationCodeLogin ? (0, _strings.getString)('ERGO_PASSWORD_RESET_EXPLANATION', [_this.nickName]) : (0, _strings.getString)('PASSWORD_RESET_EXPLANATION', [_this.nickName]);
                (0, _AlertHelper.showAlertWithOptions)({
                  html: (0, _strings.getString)(explanation, [_this.nickName]),
                  title: (0, _strings.getString)('PASSWORD_RESET'),
                  centeredContent: true,
                  buttons: [{
                    label: (0, _strings.getString)('OK')
                  }]
                });
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](2);
                // TODO: show error...
                (0, _AlertHelper.showAlertWithOptions)({
                  html: (0, _strings.getString)('RESET_ERROR'),
                  title: (0, _strings.getString)('FAILURE'),
                  centeredContent: true,
                  buttons: [{
                    label: (0, _strings.getString)('OK')
                  }]
                });

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 9]]);
      }));

      return function (_x6) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "revalidateUser", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(resolve, isOnlyActivationCodeLogin) {
        var response, token, tokenPart, user, myTournament, responseUser;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _UserManagementService["default"].revalidateUser(_this.code, _this.userName, _this.password, _this.nickName, _config["default"].useDrupalContent);

              case 3:
                response = _context7.sent;
                // this.setState({showLocked: false})
                _this.showLocked = false;

                if (!_config["default"].useDrupalContent) {
                  _context7.next = 12;
                  break;
                }

                _context7.next = 8;
                return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

              case 8:
                tokenPart = _context7.sent;
                token = "Bearer ".concat(tokenPart);
                _context7.next = 13;
                break;

              case 12:
                token = "Basic ".concat(window.btoa("".concat(_this.userName, ":").concat(_this.password)));

              case 13:
                _context7.next = 15;
                return (0, _TimeoutHelper.timeout)(300);

              case 15:
                if (!response.success) {
                  _context7.next = 50;
                  break;
                }

                _this.features.forEach( /*#__PURE__*/function () {
                  var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(featureName) {
                    var feature;
                    return _regenerator["default"].wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (featureName === _EquizzerRegisterHelper.FEATURE_QD) {
                              feature = new _Feature["default"](featureName, _this.code, _this.userName, _this.password, {
                                nickName: response.nickname,
                                _auth: _config["default"].useDrupalContent ? token : "Basic ".concat(window.btoa("".concat(_this.userName, ":").concat(_this.password)))
                              });
                            } else {
                              feature = new _Feature["default"](featureName, _this.code);
                            }

                            _context6.next = 3;
                            return _FeatureManager["default"].removeFeature(featureName);

                          case 3:
                            _context6.next = 5;
                            return _EquizzerActions["default"].removeActivatedFeature(featureName);

                          case 5:
                            _context6.next = 7;
                            return _FeatureManager["default"].saveFeature(feature);

                          case 7:
                            _context6.next = 9;
                            return _EquizzerActions["default"].addActivatedFeature(featureName);

                          case 9:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x9) {
                    return _ref7.apply(this, arguments);
                  };
                }()); // Save User to datastore and add feature 'equeoQD'


                user = {
                  id: _this.userName,
                  password: _this.password,
                  nickName: response.nickname,
                  activatedFeatures: _this.features,
                  activationCode: _this.code,
                  _auth: token
                };
                _context7.next = 20;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_USER_AUTH, user);

              case 20:
                _context7.next = 22;
                return _EquizzerActions["default"].setUserAuth({
                  id: user.id,
                  _auth: user._auth
                });

              case 22:
                _TournamentStateHelper["default"].instance();

                _context7.next = 25;
                return _TournamentStateHelper["default"].setupInitialState();

              case 25:
                _context7.next = 27;
                return (0, _TimeoutHelper.timeout)(500);

              case 27:
                myTournament = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT);

                if (!_config["default"].useDrupalContent) {
                  _context7.next = 39;
                  break;
                }

                _context7.next = 31;
                return _RestService["default"].getUser([_this.userName], token);

              case 31:
                responseUser = _context7.sent;

                if (!(responseUser.subjects && responseUser.subjects.length > 0)) {
                  _context7.next = 37;
                  break;
                }

                _context7.next = 35;
                return _EquizzerActions["default"].setUserSubjects(responseUser.subjects);

              case 35:
                _NavigationManager["default"].goToQuizModeChooser();

                return _context7.abrupt("return");

              case 37:
                _context7.next = 47;
                break;

              case 39:
                _context7.next = 41;
                return _FeatureManager["default"].isChapterActivated("equeoqd_game_v2");

              case 41:
                if (!_context7.sent) {
                  _context7.next = 45;
                  break;
                }

                _NavigationManager["default"].goToQuizHome(Boolean(myTournament) && (0, _keys["default"])(myTournament).length > 0);

                _context7.next = 46;
                break;

              case 45:
                _NavigationManager["default"].goToQuizTraining();

              case 46:
                (0, _AppUtils.setMenuOpen)(false);

              case 47:
                resolve(true);
                _context7.next = 51;
                break;

              case 50:
                (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('LOGIN_EXPLANATION', [_this.nickName]), (0, _strings.getString)('LOGIN'), (0, _strings.getString)('PASSWORD_ERROR'), [{
                  label: (0, _strings.getString)('PASSWORD'),
                  style: {
                    paddingBottom: '10px'
                  },
                  value: _this.password,
                  onChange: _this.setPassword,
                  onFocus: _this.onFocus,
                  onBlur: _this.onBlur,
                  type: 'password'
                }], true, null, [{
                  label: (0, _strings.getString)('OK'),
                  callback: function callback() {
                    _this.revalidateUser(resolve);
                  }
                }, {
                  label: (0, _strings.getString)('PASSWORD_RESET'),
                  callback: function callback() {
                    _this.resetPassword(isOnlyActivationCodeLogin);
                  },
                  theme: 'pwReset'
                }]);

              case 51:
                _context7.next = 56;
                break;

              case 53:
                _context7.prev = 53;
                _context7.t0 = _context7["catch"](0);
                (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('LOGIN_EXPLANATION', [_this.nickName]), (0, _strings.getString)('LOGIN'), (0, _ErrorHelper.getErrorMessage)(_context7.t0), [{
                  label: (0, _strings.getString)('PASSWORD'),
                  value: _this.password,
                  onChange: _this.setPassword,
                  onFocus: _this.onFocus,
                  onBlur: _this.onBlur,
                  type: 'password'
                }], true, null, [{
                  label: (0, _strings.getString)('OK'),
                  callback: function callback() {
                    _this.revalidateUser(resolve, isOnlyActivationCodeLogin);
                  }
                }, {
                  label: (0, _strings.getString)('PASSWORD_RESET'),
                  callback: function callback() {
                    _this.resetPassword(isOnlyActivationCodeLogin);
                  },
                  theme: 'pwReset'
                }]);

              case 56:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 53]]);
      }));

      return function (_x7, _x8) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "registerUser", /*#__PURE__*/function () {
      var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(resolve) {
        var error, textFields;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                error = null;
                _context8.prev = 1;

                if (!_this.requiresEmail) {
                  _context8.next = 5;
                  break;
                }

                if (!(!_this.email || !_StringHelper["default"].isEmailAdress(_this.email))) {
                  _context8.next = 5;
                  break;
                }

                throw new Error((0, _ErrorHelper.getErrorMessage)('invalid email'));

              case 5:
                if (!(!_this.password || !_this.password2 || _this.password !== _this.password2)) {
                  _context8.next = 7;
                  break;
                }

                throw new Error((0, _ErrorHelper.getErrorMessage)('password doesnt match'));

              case 7:
                _context8.next = 9;
                return (0, _EquizzerRegisterHelper.registerUser)(_this.code, _this.nickName, _this.password, _this.email, _this.password2, function () {
                  _this.showLocked = false;
                }, true, _config["default"].useDrupalContent);

              case 9:
                error = _context8.sent;
                _context8.next = 15;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8["catch"](1);
                error = _context8.t0.message;

              case 15:
                if (error) {
                  textFields = [];
                  textFields.push({
                    label: (0, _strings.getString)('PASSWORD'),
                    value: _this.password,
                    onChange: _this.setPassword,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur,
                    type: 'password'
                  }, {
                    label: (0, _strings.getString)('PASSWORD_REPEAT'),
                    value: _this.password2,
                    onChange: _this.setPassword2,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur,
                    type: 'password'
                  });

                  if (_this.requiresEmail) {
                    textFields.push({
                      label: (0, _strings.getString)('PLAYER_EMAIL'),
                      value: _this.email,
                      onChange: _this.setEmail,
                      onFocus: _this.onFocus,
                      onBlur: _this.onBlur,
                      type: 'email'
                    });
                  }

                  (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('REGISTER_EXPLANATION', [_this.nickName]), (0, _strings.getString)('REGISTER'), error, textFields, true, null, [{
                    label: (0, _strings.getString)('OK'),
                    callback: function callback() {
                      _this.registerUser(resolve);
                    }
                  }]);
                }

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[1, 12]]);
      }));

      return function (_x10) {
        return _ref8.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changePassword", /*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(resolve, isOnlyActivationCodeLogin) {
        var response;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(_this.password === _this.password2 && _this.password.length > 4)) {
                  _context9.next = 13;
                  break;
                }

                _context9.prev = 1;
                _context9.next = 4;
                return _UserManagementService["default"].changePassword(_this.userName, _this.password, null, _config["default"].useDrupalContent);

              case 4:
                response = _context9.sent;

                if (resolve) {
                  _this.revalidateUser(resolve);
                }

                _context9.next = 11;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](1);
                (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('RESET_EXPLANATION', [_this.nickName]), (0, _strings.getString)('RESET_TITLE'), (0, _ErrorHelper.getErrorMessage)(_context9.t0), [{
                  label: (0, _strings.getString)('PASSWORD'),
                  value: _this.password,
                  onChange: _this.setPassword,
                  onFocus: _this.onFocus,
                  onBlur: _this.onBlur,
                  type: 'password'
                }, {
                  label: (0, _strings.getString)('PASSWORD_REPEAT'),
                  value: _this.password2,
                  onChange: _this.setPassword2,
                  onFocus: _this.onFocus,
                  onBlur: _this.onBlur,
                  type: 'password'
                }], true, null, [{
                  label: (0, _strings.getString)('OK'),
                  callback: function callback() {
                    _this.changePassword(resolve, isOnlyActivationCodeLogin);
                  }
                }, {
                  label: (0, _strings.getString)('PASSWORD_RE_RESET'),
                  callback: function callback() {
                    _this.resetPassword(isOnlyActivationCodeLogin);
                  },
                  theme: 'pwReset'
                }]);

              case 11:
                _context9.next = 23;
                break;

              case 13:
                if (!(_this.password.length < 5 && _this.password)) {
                  _context9.next = 19;
                  break;
                }

                _context9.next = 16;
                return (0, _TimeoutHelper.timeout)();

              case 16:
                (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('RESET_EXPLANATION', [_this.nickName]), (0, _strings.getString)('RESET_TITLE'), (0, _strings.getString)('PASSWORD_SHORT'), [{
                  label: (0, _strings.getString)('PASSWORD'),
                  value: _this.password,
                  onChange: _this.setPassword,
                  onFocus: _this.onFocus,
                  onBlur: _this.onBlur,
                  type: 'password'
                }, {
                  label: (0, _strings.getString)('PASSWORD_REPEAT'),
                  value: _this.password2,
                  onChange: _this.setPassword2,
                  onFocus: _this.onFocus,
                  onBlur: _this.onBlur,
                  type: 'password'
                }], true, null, [{
                  label: (0, _strings.getString)('OK'),
                  callback: function callback() {
                    _this.changePassword(resolve, isOnlyActivationCodeLogin);
                  }
                }, {
                  label: (0, _strings.getString)('PASSWORD_RE_RESET'),
                  callback: function callback() {
                    _this.resetPassword(isOnlyActivationCodeLogin);
                  },
                  theme: 'pwReset'
                }]);
                _context9.next = 23;
                break;

              case 19:
                if (!(_this.password !== _this.password2)) {
                  _context9.next = 23;
                  break;
                }

                _context9.next = 22;
                return (0, _TimeoutHelper.timeout)();

              case 22:
                (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _strings.getString)('RESET_EXPLANATION', [_this.nickName]), (0, _strings.getString)('RESET_TITLE'), (0, _strings.getString)('PASSWORD_MATCH_ERROR'), [{
                  label: (0, _strings.getString)('PASSWORD'),
                  value: _this.password,
                  onChange: _this.setPassword,
                  onFocus: _this.onFocus,
                  onBlur: _this.onBlur,
                  type: 'password'
                }, {
                  label: (0, _strings.getString)('PASSWORD_REPEAT'),
                  value: _this.password2,
                  onChange: _this.setPassword2,
                  onFocus: _this.onFocus,
                  onBlur: _this.onBlur,
                  type: 'password'
                }], true, null, [{
                  label: (0, _strings.getString)('OK'),
                  callback: function callback() {
                    _this.changePassword(resolve, isOnlyActivationCodeLogin);
                  }
                }, {
                  label: (0, _strings.getString)('PASSWORD_RE_RESET'),
                  callback: function callback() {
                    _this.resetPassword(isOnlyActivationCodeLogin);
                  },
                  theme: 'pwReset'
                }]);

              case 23:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[1, 8]]);
      }));

      return function (_x11, _x12) {
        return _ref9.apply(this, arguments);
      };
    }());
    _this.state = {};
    _this.code = '';
    _this.modalTop = 0;
    _this.nickName = '';
    _this.password = '';
    _this.password2 = '';
    _this.userName = _this.showLocked = false;
    _this.features = [];
    _this.groupName = '';
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(EquizzerCanOpenChecker.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_ACTIVATED_FEATURES]);
    _this.requiresEmail = false;
    _this.alreadyOpen = false;
    return _this;
  }

  (0, _createClass2["default"])(EquizzerCanOpenChecker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('reauthorizationRequested', this.onReauthorizationRequested);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('reauthorizationRequested', this.onReauthorizationRequested);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(EquizzerCanOpenChecker.prototype), "componentWillUnmount", this).call(this);
    }
  }]);
  return EquizzerCanOpenChecker;
}(_CheckCanOpenComponent["default"]);

var _default = EquizzerCanOpenChecker;
exports["default"] = _default;